/* ============
 * Actions for the profile module
 * ============
 *
 * The actions that are available on the
 * profile module.
 */
import Vue from 'vue';
import UserProxy from '@/proxies/UserProxy';
import message from '@/constants/_message';
import types from './mutation-types';
import eventBus from '@/plugins/event-bus';
import EVENTS from '@/constants/_events';

export const viewAll = ({ commit }, data) => {
  commit(types.FETCH_ALL_USERS);
  new UserProxy().viewAll(data)
    .then((response) => {
      commit(types.FETCH_ALL_USERS_SUCCESS, response);
    }).catch((error) => {
      commit(types.FETCH_ALL_USERS_FAIL, error);
    });
};

export const view = ({ commit }, id) => {
  commit(types.FETCH_USER);
  new UserProxy().view(id)
    .then((response) => {
      commit(types.FETCH_USER_SUCCESS, response);
    }).catch((error) => {
      commit(types.FETCH_USER_FAIL, error);
    });
};

export const update = ({ commit }, data) => {
  commit(types.UPDATE_USER);
  new UserProxy().update(data)
    .then((response) => {
      commit(types.UPDATE_USER_SUCCESS, response);
      Vue.notify({
        group: 'notification',
        title: 'Success',
        text: message.USER_UPDATED,
        type: 'success'
      });
      Vue.router.push({
        name: 'user.view'
      });
    }).catch((error) => {
      commit(types.UPDATE_USER_FAIL, error);
      Vue.notify({
        group: 'notification',
        title: 'Error',
        text: message.USER_NOT_UPDATED,
        type: 'error'
      });
    });
};

export const remove = ({ commit }, data) => {
  commit(types.DELETE_USER);
  new UserProxy().update(data)
    .then((response) => {
      commit(types.DELETE_USER_SUCCESS, response.id);
      Vue.notify({
        group: 'notification',
        title: 'Success',
        text: message.USER_DELETED,
        type: 'success'
      });
    }).catch((error) => {
      commit(types.DELETE_USER_FAIL, error);
      Vue.notify({
        group: 'notification',
        title: 'Error',
        text: message.USER_NOT_DELETED,
        type: 'error'
      });
    });
};

export const create = ({ commit }, data) => {
  commit(types.CREATE_USER);
  new UserProxy().create(data)
    .then((response) => {
      commit(types.CREATE_USER_SUCCESS, response);
      Vue.notify({
        group: 'notification',
        title: 'Success',
        text: message.USER_CREATED,
        type: 'success'
      });
      Vue.router.push({
        name: 'user.view',
        params: { id: response.id }
      });
    }).catch(({ error }) => {
      commit(types.CREATE_USER_FAIL, error);
      Vue.notify({
        group: 'notification',
        title: 'Error',
        text: error.message || message.USER_NOT_CREATED,
        type: 'error'
      });
    });
};

export const resetUser = ({ commit }) => {
  commit(types.RESET_USER);
};

export const changePassword = ({ commit }, data) => {
  commit(types.CHANGE_PASSWORD);
  new UserProxy().changePassword(data)
    .then((response) => {
      commit(types.CHANGE_PASSWORD_SUCCESS, response);
      eventBus.$emit(EVENTS.USER_LOGOUT);
      Vue.notify({
        group: 'notification',
        title: 'Password Changed Successfully, Please Login',
        text: message.PASSWORD_UPDATED,
        type: 'success'
      });
    }).catch((error) => {
      commit(types.CHANGE_PASSWORD_FAIL, error);
      Vue.notify({
        group: 'notification',
        title: 'Error',
        text: message.PASSWORD_NOT_UPDATED,
        type: 'error'
      });
    });
}

export const requestDemo = ({ commit }, data) => {
  commit(types.REQUEST_DEMO);
  new UserProxy().requestDemo(data)
    .then(() => {
      commit(types.REQUEST_DEMO_SUCCESS);
    }).catch((error) => {
      commit(types.REQUEST_DEMO_FAIL, error);
    });
};


export default {
  create,
  view,
  viewAll,
  update,
  remove,
  resetUser,
  changePassword,
  requestDemo
};
